import { Model } from 'modules/core/lib/mobx-rest'

interface Permission {
  create: boolean
}

interface IEmployeePermission {
  id: number
  permissions: Permission
}

class EmployeePermission extends Model<IEmployeePermission> {
  static urlRoot() {
    return '/shift_management/employees_permissions'
  }
}

export default EmployeePermission
